export enum RunProgressStepStatus {
  DONE = 'DONE',
  RUNNING = 'RUNNING',
  WAITING = 'WAITING',
  DECLINED = 'DECLINED',
  FAILED = 'FAILED',
  NOT_RUN = 'NOT_RUN',
}

export enum RunProgressEntryKind {
  STEP = 'STEP',
  USER_MESSAGE = 'USER_MESSAGE',
  AGENT_REPLY = 'AGENT_REPLY',
  ITEM = 'ITEM',
}

export enum RunProgressStepKind {
  ACTION = 'ACTION',
  PLAN_APPROVED = 'PLAN_APPROVED',
  LOCAL_ACTIVITY = 'LOCAL_ACTIVITY',
  PENDING_ACTION = 'PENDING_ACTION',
  DECISION = 'DECISION',
  NOT_RUN = 'NOT_RUN',
}
